import React, { useState, useEffect } from "react";
import Modal from "@src/common/ModalPopup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getRoleListing } from "@src/store/slices/RoleUser";
import { getMasterConfig } from '@src/store/slices/common';
import InputField from "@src/common/InputField"
import {addAgencyUsers} from '@src/store/slices/agency';
import ToggleSwitch from '@src/common/ToggleSwitch';
import { STATUS_SUCCESS, EMAIL_DOMAINS } from "@src/config/constant";


function AddAgencyUserPopup(params: any) {
    let { addNewUser, showUserRole ,agency_id} = params;
    let [formData, setFormData] = useState<any>({ status: "0" });
    let [userList, setUserList] = useState<any>([]);
    let [errors, setErrors] = useState<any>({});
    const mobile_regex = /^[9]\d{9}$/;
    const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const password_regex = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/ // eslint-disable-line
    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common);
    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        getUserList();
        // eslint-disable-next-line
    }, []);

    const getUserList = async () => {
        dispatch(getRoleListing.getUserManagementList({ isPaginationApply: false })).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                let userList = [];
                userList = (res.data && res.data.length && formData) ?
                    res.data.map((e: any) => {
                        let isChecked = formData.reportee_id ? formData.reportee_id === e.id : false;
                        return {
                            value: e.id,
                            label: e.name,
                            isChecked: isChecked,
                            assigned_role: e.assigned_role_ids ? e.assigned_role_ids.split(',') : []
                        }
                    }) : [];
                setUserList([...userList]);
            }
        })
    };

    const handleChange = async (key: any, event: any) => {
        let value: any = '';
        
        if (key === 'status') {
            value = formData.status === "1" ? "0" : "1";
        }
        else if (event instanceof Array) {
            value = event.map((e) => e.value);
        }
        else if (event && event.target) {
            value = event.target.value;
        }
        else if (key === "reportee_role_id") {
            value = event.value || event.id;
            formData["reportee_id"] = null;
        }
        else if (event) {
            value = event.value || event.id;
        }
        formData[key] = value;
        errors[key] = '';
        setFormData({ ...formData });
        setErrors({ ...errors });
    }

    const isFormValid = (formData: any) => {
        let isValid = true;
        if (!formData.name || formData.name === '') {
            errors['name'] = 'Name is required';
            isValid = false;
        } else if (formData && formData.name && (formData.name.split('').length < 3 || formData.name.split('').length > 30)) {
            errors['name'] = 'Name should be between 3 to 30';
            isValid = false;
        }
        
        if(formData?.mobile?.length && !mobile_regex.test(formData.mobile)){
            errors['mobile'] = 'Mobile number should start from 9 and should be 10 digits.';
            isValid = false;
        }

        if (!formData.email || formData.email === '') {
            errors['email'] = 'Email is required';
            isValid = false;
        } else if (!email_regex.test(formData.email)) {
            errors['email'] = 'Invalid Email';
            isValid = false;
        }
        else {
            // domain not allow check
            const emailDomain = formData.email.split("@")[1]?.toLowerCase() || "";
            if (EMAIL_DOMAINS.some((d:any) => emailDomain.includes(d))) {
                errors['email'] = 'Emails from ZenInsure or Carmudi are not allowed';
                isValid = false;
            }
        }
        if (!formData.password || formData.password === '') {
            errors['password'] = 'Password is required';
            isValid = false;
        } 
        else if (!password_regex.test(formData.password)) {
            errors['password'] = 'Password should be atleast 8 character with 1 special char,1 Uppercase,1 lowercase and 1 digit';
            isValid = false;
        }
        setErrors({ ...errors });
        return isValid;

    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setFormData({ ...formData, agency_id });
        let prevStatus = formData.status; 
        let postData = await getFormData();
        if (isFormValid(postData)) {
        params.setLoading(true);

        let newObj = formData
        newObj.agency_id = agency_id;
            dispatch(addAgencyUsers(newObj)).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    toast.success(res.data);
                    params.setTriggerAgencyList(params.triggerAgencyList+1);
                    params.setLoading(false);
                    setFormData({ status: "0" });
                    setFormData({})
                    params.addNewUser(false);
                } else {
                    params.setLoading(false);
                    setFormData((prevData: any) => ({ ...prevData, status: prevStatus }));
                }
            })
        }
        params.setSearchText('');
    }

    const getFormData = async () => {
        let postData:any = {};
       
        if (formData && formData.name) postData['name'] = formData.name?.replace(/\s+/g,' ').trim();
        if (formData && formData.email) postData['email'] = formData.email?.replace(/\s+/g,' ').trim();
        if (formData && formData.password) postData['password'] = formData.password?.replace(/\s+/g,' ').trim();
        if (formData && formData.mobile) postData['mobile'] = formData.mobile;
        if(formData && formData.status) postData['status'] = formData.status || "0";
        if(formData && formData.id) postData['id'] = formData.id;
        return postData;
    }
    let user_list : any = []
    if (formData && formData.reportee_role_id) {
        // eslint-disable-next-line
        user_list = userList.filter((e: any) => {
            return e.assigned_role?.includes(String(formData.reportee_role_id))
        });
    } 

    return (

        <React.Fragment>
            <div className="user-screen-popup user-managent-add-user-popup">
                <Modal handleClose={() => addNewUser(false)} show={showUserRole}>
                    <div className="modal-header">
                        <h2>Add New User</h2>
                    </div>
                    <div className="modal-body" >

                        <div className="row">

                            <div className="add-user-data col-md-12">
                                       
                                            <fieldset className="form-filed">
                                                <div className="material">
                                                    <input id="" type="text" placeholder=" " name="Name" className="form-input" value={formData.name || ''} onChange={(e: any) => handleChange("name", e)} />
                                                    <label data-label="User Name*" className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.name || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                            <fieldset className="form-filed">
                                                <div className="material">
                                                    <input id="email" type="text" placeholder=" " name="email" className="form-input" value={formData.email || ''} onChange={(e: any) => handleChange("email", e)} />
                                                    <label data-label="Email ID*" className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.email || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                            
                                            <fieldset className="form-filed">
                                                <div className="material">
                                                    <InputField
                                                    inputProps={{
                                                        id: "mobile",
                                                        name: "mobile",
                                                        className: "form-input",
                                                        type: "text",
                                                        value: formData.mobile ? formData.mobile : '',
                                                        maxLength: "10",
                                                        disabled: false,
                                                        placeholder: " "

                                                    }}
                                                  onChange={(e: any) => handleChange("mobile", e)}
                                                />

                                                    <label data-label="Mobile No" className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.mobile || ""}
                                                    </span>                                
                                                </div>
                                            </fieldset>
                                            
                                            <fieldset className="form-filed">
                                                <div className="material">
                                                    <input id="password" type="text" placeholder=" " name="password" className="form-input" value={formData.password || ''} onChange={(e: any) => handleChange("password", e)} />
                                                    <label data-label="Password*" className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.password || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                           

                                <fieldset className="form-filed">
                                    <div className="material status-btn">
                                        <ToggleSwitch 
                                        checked={String(formData.status) === "1" ? true : false}
                                        onChange={(e: any) => handleChange('status', e)}
                                         />
                                        <div className="status-txt">{String(formData.status) === "1" ? "Active" : "Inactive"}</div>
                                    </div>
                                </fieldset>
                                       
                            </div>
                            <button className="btn-primary m-md-t" onClick={(e: any) => handleSubmit(e)}>Add User</button>
                        </div>

                    </div>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default AddAgencyUserPopup